export default __webpack_public_path__ + "static/media/53.b35b77f2.jpeg";